'use strict';

/**
 * The helpers exported in this file are used to calculate
 * the condition details that will appear on the pdp.
 * Copy for the details titles is not determined in these helpers.
 * These methods return only the information that will
 * appear under a detail's title.
 */

const schemaTypes = require('../../constants/schemaTypes');

module.exports = {
    /**
     *
     * Get an array containing one object that DetailsItem.jsx will use to render this detail.
     * The object will have a key 'value', which holds the display data for the condition.
     *
     * @param {object} config
     * @param {object} config.item                 - Bunsen Item Model
     * @param {object} config.conditionReferences  - see this.conditionReferences in ItemStore for definition {@link newPdp/ItemStore}
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean,
     *          }[]}
     *
     * ie: [{
     *          value: 'Excellent',
     *          isLink: boolean
     *     }]
     */
    getCondition: function(config) {
        const { item, conditionReferences } = config;
        const contents = [];

        let conditions = [];
        // Want to check if the item has each of these conditions.
        const conditionState = item.get('condition.state');
        let conditionDescription = item.get('condition.description');
        const conditionOriginalBox = item.get('condition.hasOriginalBox');
        let conditionFormatted;

        // Then apply specific logic for each condition,
        // to transform it into a more display friendly format.
        if (conditionState && conditionReferences) {
            const reference = conditionReferences[conditionState];
            const displayName = reference && reference.displayName ? reference.displayName : '';
            conditions.push(displayName);
        }

        if (conditionDescription) {
            conditionDescription =
                conditionDescription.charAt(0).toUpperCase() + conditionDescription.substring(1);
            conditions.push(conditionDescription);
        }

        if (conditionOriginalBox && conditionOriginalBox === 'Y') {
            conditions.push('In original box');
        }

        // Add a string with one space so when we perform a join
        // below, the last string in conditions has a period.
        if (conditions.length > 1) {
            conditions.push(' ');
        }

        if (conditions.length > 0) {
            // And finally join the conditions into one string.
            conditionFormatted = conditions.join('. ').trim();
            contents.push({
                isLink: false,
                value: conditionFormatted,
                schemaType: schemaTypes.condition,
            });
        }

        return contents;
    },

    /**
     *
     * Get an array containing one object that DetailsItem.jsx will use to render this detail.
     * The object will have a key 'value', which holds the display data for the wear.
     *
     * @param {object} config
     * @param {object} config.item - Bunsen Item Model
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean,
     *          }[]}
     *
     * ie: [{
     *          value: 'Wear consistent with age and use',
     *          isLink: boolean
     *     }]
     */
    getWear: function(config) {
        const contents = [];
        const item = config.item;

        const wear = [];
        const wearKeys = [
            'damageLight',
            'damageDesignerAltered',
            'damageOtherAltered',
            'damageLosses',
            'damageSound',
            'damageFading',
            'damageRestored',
            'damageServiced',
        ];
        const wearCopy = {
            damageLight: 'Wear consistent with age and use',
            damageDesignerAltered: 'Alteration made by original designer',
            damageOtherAltered: 'Altered (not by designer)',
            damageLosses: 'Minor losses',
            damageSound: 'Minor structural damages',
            damageFading: 'Minor fading',
            damageRestored: 'Restored',
            damageServiced: 'Recently Serviced',
        };
        const condition = item.get('condition');

        let wearKey;
        let wearFormatted;

        if (!condition) {
            return contents;
        }

        // If the item's condition has one of these wear as a key,
        // and the value is 'Y', push the copy for that wear.
        for (wearKey of wearKeys) {
            if (condition.get(wearKey) && condition.get(wearKey) === 'Y') {
                wear.push(wearCopy[wearKey]);
            }
        }

        // Add a string with one space so when we perform a join
        // below, the last string in wear has a period.
        if (wear.length > 1) {
            wear.push(' ');
        }

        if (wear.length > 0) {
            // Join the wear into one string.
            wearFormatted = wear.join('. ').trim();
            contents.push({
                isLink: false,
                value: wearFormatted,
                schemaType: schemaTypes.condition,
            });
        }

        return contents;
    },
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/details/helpers/detailsCondition.es.js